import type {Command} from '@codemirror/view'

import {WRAP_DELIMITER_MAP, type WrappableDelimiter} from './constants'
import {wrapSelectionWithDelimiter} from './utils'

export const wrapWithDelimiter =
  (delimiter: WrappableDelimiter): Command =>
  view => {
    if (view.state.selection.main.empty) return false

    const suffix = WRAP_DELIMITER_MAP[delimiter]
    wrapSelectionWithDelimiter(view, delimiter, suffix)

    return true
  }
